import * as yup from "yup";
import {
  fieldMaxLength,
  requiredField,
} from "../../../../infrastructure/helpers/yupHelper";

export const noteFormSchema = yup
  .object({
    entityId: yup.number().min(1).nullable().defined(),

    content: yup
      .string()
      .required(requiredField("Бележка"))
      .min(1)
      .max(300, fieldMaxLength("Бележка", 300))
      .defined(),
  })
  .required();

export type NoteFormData = yup.InferType<typeof noteFormSchema>;

export const noteFormDefaultValues: NoteFormData = {
  entityId: null,
  content: "",
};
